/* istanbul ignore file */
import routes from './routes';

function createRouter(VueRouter) {
  return new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return { x: 0, y: 0 };
    },
  });
}

export default createRouter;
